import { VhTools } from "msd";

const getRootDomain = () => {
  const url = window.location.hostname;
  console.log("getRootDomain =================>", url);
  const rootDomain: RegExpMatchArray | null =
    url.match(/\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/g) ||
    url.match(/([a-z0-9][a-z0-9]*?\.(?:com|cn|net|org|gov|info|la|cc|co|jp)(?:\.(?:cn|jp))?)$/);
  if (!rootDomain) {
    return;
  }
  return rootDomain[0];
};

export const DOMAIN = getRootDomain() || "viphrm.com";

export const LOGIN_URL = `${
  process.env.REACT_APP_ENV === "pro" ? "https" : "http"
}://${
  process.env.REACT_APP_ENV !== "pro"
    ? process.env.REACT_APP_ENV === "test"
      ? "dv"
      : process.env.REACT_APP_ENV === "pre"
      ? "test"
      : "dev"
    : ""
}login.${DOMAIN}${process.env.REACT_APP_ENV === "dev" ? ":8088" : ""}`;

export const HOME_PAGE = `http://${
  process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : ""
}moss.${DOMAIN}`;
export const MAIN_PAGE = `http://${
  process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : ""
}home.${DOMAIN}`;
export const PERSONAL_PAGE = `${
  process.env.REACT_APP_ENV === "pro" ? "https" : "http"
}://${
  process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : ""
}config.${DOMAIN}/personal`;
export const COMPANY_PAGE = `${
  process.env.REACT_APP_ENV === "pro" ? "https" : "http"
}://${
  process.env.REACT_APP_ENV !== "pro" ? process.env.REACT_APP_ENV : ""
}config.${DOMAIN}/company`;

export const ERROR_MESSAGE = "系统维护中，请联系管理员。";

export const TOKEN =
  VhTools.getCookie("ms_member_token") ||
  (process.env.REACT_APP_ENV === "dev"
    ? "209157.eyJhbGciOiJIUzI1NiJ9.eyJhcHBpZCI6IjEzMDAxIiwiZXhwIjoxNzY2MTQyODIxLCJ1c2VyaWQiOiIyMDkxNTcifQ.3-cswo0N4XMA7acjAUgIvDHaoFvUHpvqLae179CgKIU"
    : "");

export const CID =
  VhTools.getCookie("ms_cid") ||
  (process.env.REACT_APP_ENV === "dev" ? "288572" : "");

export const APP_CODE = "studio";

/** 彩色logo */
export const LOGO_COLORFUL =
  "https://cs-common.oss-cn-hangzhou.aliyuncs.com/e_header_logo_colorful@2x.png";
